import { IntlShape } from 'react-intl';

import { addDefaultErrorMessageActionI18n } from 'containers/FlashMessage/actions';

/**
 * Generated clients expect to receive a string.
 * There's precedent for this coercion in the codebase when sending csv files.
 * The common __request function used by generated clients does check for the
 * payload actually being a File and handles it accordingly
 * @param file
 * @returns
 */
export const coerceTerminologyFileType = (file: File): string =>
  file as unknown as string;

export const getMessageFromResult = (result: unknown, intl: IntlShape) => {
  const defaultAnswer = addDefaultErrorMessageActionI18n(intl).text;

  if (!result || typeof result !== 'object') {
    return defaultAnswer;
  }

  if (!('message' in result)) {
    return defaultAnswer;
  }

  const { message } = result as Record<string, unknown>;
  if (typeof message !== 'string') {
    return defaultAnswer;
  }

  return message;
};
